import { Button, Grid } from "@material-ui/core";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { Add, Search } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import FilterListIcon from "@material-ui/icons/FilterList";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import SyncIcon from "@material-ui/icons/Sync";
import { useFormikContext } from "formik";
import { useStore } from "app/stores";
import { isAdmin, isDoctor, isRoleBranchManager, isRoleCashier, isRoleChiefTechician, isRoleHisAccountant, isRoleHisReadOnly, isRoleTechician, isSalesConsultant } from "app/common/LocalFunction";
const SearchRegisterMedicalSupply = () => {
  let [isOpenFillter, setOpenFillter] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const { values } = useFormikContext();
  const {
    handleOpenCreateOrEditMedicalPopup,

    handleOpenAddMedicalSupplyAdvicePopup,
  } = useStore().patientManagementStore.registerMedicalSupplyStore;

  let isRoleCashierPermission = isRoleCashier();
  let isRoleBranchManagerPermission = isRoleBranchManager();
  let isSalesConsultantPermission = isSalesConsultant();
  const isReadonly = isRoleHisReadOnly();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();

  const hasAddPermission = isAdmins || isRoleCashierPermission || isAccountant || isRoleBranchManagerPermission
  return (
    <>
      <Grid item xs={12} style={{ padding: "8px 0" }}>
        <div className="flex" style={{ justifyContent: "space-between" }}>
          <div className="flex">
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                margin: 0,
                padding: "5px",
              }}
            >
              4.2.Vật tư
            </p>
            <span
              style={{ cursor: "pointer" }}
              className="flex items-center"
              onClick={() => setOpenFillter(!isOpenFillter)}
            >
              <FilterListIcon color="red" />
            </span>
          </div>

          {
            hasAddPermission &&
            (
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <CommonButton
                  className="btn-add"
                  onClick={async (e) => setAnchorEl(anchorEl ? null : e.target)}
                  style={{ position: "relative", height: "100%" }}
                >
                  <Add />
                  Vật tư
                </CommonButton>

                {anchorEl && (
                  <div
                    className="popover-list"
                    style={{
                      right: 0,
                      left: "auto",
                      position: "absolute",
                      minWidth: "160px",
                    }}
                  >
                    <div
                      className="popover-item popover-item-custom"
                      style={{ color: "#4276a4" }}
                      onClick={() => {
                        handleOpenCreateOrEditMedicalPopup();
                        setAnchorEl(null);
                      }}
                    >
                      <AddCircleOutlineIcon fontSize="small" className="icon" />
                      Thêm
                    </div>
                    <div
                      className="popover-item"
                      style={{ color: "#4276a4" }}
                      onClick={() => {
                        handleOpenAddMedicalSupplyAdvicePopup({
                          orderDate: values?.orderDate,
                          patientId,
                        });
                        setAnchorEl(null);
                      }}
                    >
                      <SyncIcon fontSize="small" color="#007b8f" className="icon" />
                      Lấy từ tư vấn
                    </div>
                  </div>
                )}
              </div>
            )
          }

        </div>
      </Grid>
      {!isOpenFillter && (
        <>
          <style>
            {`
            @keyframes slideDownFade {
              0% {
                opacity: 0;
                transform: translateY(-10px);
              }
              100% {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
          </style>
          <div
            style={{
              animation: "slideDownFade 0.3s ease forwards",
            }}
          >
            <Grid container spacing={1} className="cards-body">
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsTextField
                  label="Tìm kiếm"
                  name="keyword"
                  placeholder={"Nhập tên/Mã dịch vụ"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsDateTimePicker
                  label="Ngày đăng ký từ"
                  name="fromDate"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsDateTimePicker label="Ngày đăng ký đến" name="toDate" />
              </Grid>
              {/* 
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsPagingAutocomplete
              api={pagingServiceGroup}
              name={"groupId"}
              label="Nhóm dịch vụ"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <GlobitsPagingAutocomplete
              api={pagingHealthCareService}
              label={"Dịch vụ"}
              name={"healthCareSvId"}
              searchObject={{ groupId: values?.groupId?.id }}
              renderOption={(item) => (
                <div
                  className="flex-wrap gap-1 w-100"
                  style={{ borderBottom: "1px solid #ccc" }}
                >
                  <b>{item?.name || ""}</b>({item?.code || ""})
                </div>
              )}
              searchFields={["name", "code"]}
            />
          </Grid> */}

              <Grid
                item
                xs={12}
                sm={6}
                md={"3"}
                className="flex flex-end gap-2"
              >
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default memo(observer(SearchRegisterMedicalSupply));
